
import { Service } from '@angular/core';

@Service()
export class CurrencyService {

  getSymbol(currencyCode: string | null | undefined): string {
    if (!currencyCode) {
      return '';
    }

    try {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol'
      })
        .formatToParts(0)
        .find(part => part.type === 'currency')
        ?.value ?? currencyCode;
    } catch {
      return currencyCode;
    }
  }
}
